import React, { useEffect, useState } from "react";
import {
  Button,
  ButtonToolbar,
  Form,
  Loader,
  Container,
  Content,
  Checkbox,
  Modal,
} from "rsuite";
import { CommercialScheduleServices } from "../../../core/services/CommercialScheduleServices";
import { UtilityServices } from "../../../core/services/UtilityServices";
import "./CommercialSchedules.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  displayDateField,
  displayDateTimeField,
  displayField,
  displayTimeField,
  formatTimeField,
  isEmptyVal,
} from "../../../utils/helpers";

const ViewCommercialScheduleModal = (props: any) => {
  const { t } = useTranslation();
  const commercialScheduleId = useSelector((state: any) => {
    return state?.actionData?.id;
  });
  const [loader, setLoader] = useState(false);
  const [commercialScheduleInfo, setCommercialScheduleInfo] = useState<any>({});
  async function getViewCommercialScheduleDetail(id: number) {
    try {
      setLoader(true);
      const res = await CommercialScheduleServices.viewCommercialSchedule(id);
      setLoader(false);
      if (res && res.data && res.data.data) {
        setCommercialScheduleInfo({ ...res.data.data });
      }
    } catch (error) {
      setLoader(false);
    }
  }
  useEffect(() => {
    getViewCommercialScheduleDetail(commercialScheduleId);
  }, []);

  return (
    <div className="modal-container">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content={t("LOADING")}
          center
          backdrop={true}
        />
      )}
      <Modal
        open={props.status}
        backdrop={false}
        onClose={(e: any) => {
          props.toggle("");
        }}
      >
        <Modal.Header>
          <h4 className="text-center">
            {t("VIEW")} {t("COMMERCIAL_SCHEDULE")}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <div className="commercial-schedules view-commercial-schedules">
            <Container className="container">
              {commercialScheduleInfo &&
              Object.keys(commercialScheduleInfo).length ? (
                <Content>
                  <Form layout="inline">
                    <Form.Group controlId="name">
                      <Form.ControlLabel>{t("NAME")} : </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(
                          `${commercialScheduleInfo?.schedule_title}`
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="total_items">
                      <Form.ControlLabel>
                        {t("TOTAL")} {t("ITEMS")} :
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(
                          `${
                            isEmptyVal(commercialScheduleInfo?.total_items)
                              ? 0
                              : commercialScheduleInfo?.total_items
                          }`
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="max_items">
                      <Form.ControlLabel>
                        {t("MAX")} {t("ITEMS")} :
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${commercialScheduleInfo?.max_items}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="schedule_date_from">
                      <Form.ControlLabel>
                        {t("SCHEDULE")} {t("START")} {t("DATE")} :
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayDateField(
                          commercialScheduleInfo?.schedule_date_from
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="schedule_date_to">
                      <Form.ControlLabel>
                        {t("SCHEDULE")} {t("END")} {t("DATE")} :
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayDateField(
                          commercialScheduleInfo?.schedule_date_to
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="schedule_starts_at">
                      <Form.ControlLabel>
                        {t("SCHEDULE")} {t("START")} {t("TIME")} :
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {formatTimeField(
                          commercialScheduleInfo?.schedule_starts_at,
                          "12hr"
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="schedule_ends_at">
                      <Form.ControlLabel>
                        {t("SCHEDULE")} {t("END")} {t("TIME")} :
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {formatTimeField(
                          commercialScheduleInfo?.schedule_ends_at,
                          "12hr"
                        )}
                      </Form.ControlLabel>
                    </Form.Group>

                    <Form.Group controlId="new_schedule_everyday">
                      <Form.ControlLabel>
                        {t("NEW")} {t("SCHEDULE")} {t("DAILY")} :
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {commercialScheduleInfo?.new_schedule_everyday.toString() ===
                        "1"
                          ? t("YES")
                          : t("NO")}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="company">
                      <Form.ControlLabel>{t("COMPANY")} :</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(
                          `${commercialScheduleInfo?.company?.comp_name}`
                        )}{" "}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="stores">
                      <Form.ControlLabel>{t("STORES")} :</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${commercialScheduleInfo?.stores}`)}{" "}
                      </Form.ControlLabel>
                    </Form.Group>
                  </Form>
                </Content>
              ) : null}
            </Container>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ViewCommercialScheduleModal;
